import React, { useEffect, useState } from "react";
import { Modal as AntModal, Input, Tabs, Button, Badge, Select, message } from "antd";
import "./viewPipeline.css";
import { Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { CloseOutlined } from "@ant-design/icons";
import TaskListTab from "../ViewPipelinesTabs/TaskListTab";
import ActivityStreamTab from "../ViewPipelinesTabs/ActivityStreamTab";
import AwsServerService from "../../../common/util/AwsServerService";
import swal from "sweetalert";
// import StatusTimeline from "../ViewPipelinesTabs/StatusTimeline";
import { useSelector } from "react-redux";
import { canAccess } from "../../../common/util/appUtils";
import HierarchicalDropdown from "../../../components/Roles/HierarchicalDropdown";
import { set } from "lodash";

const ViewPipelines = ({
  open,
  setOpen,
  viewPipelineData,
  viewTaskFunction,
  setViewPipelineData,
  refreshData,
  setPageRefreshData,
  openTaskModal,
  setOpenTaskModal,
  allPipelineData,
  selectedTable,
  history,
  allBlueprintsData,
  dropdownTasksDataCache,
  allTasksAndSubtasks   ,
  setDependencyRefresh  ,
  allDependeniesData,
  zohoServices,
  isPipelineModalClosed
}) => {
  const userInfo = JSON.parse(localStorage.getItem("userinfo"));
  const initialPipelineData = {};
  const [pipelineData, setPipelineData] = useState(initialPipelineData);  
  const [isAdding, setIsAdding] = useState(false);
  const [accessControlData, setAccessControlData] = useState([]);
  const accessContext = useSelector(state => state.UserContext.accessContext)
  const canEdit = canAccess(accessContext, "Pipeline Template", "Edit");
  useEffect(e=>{
    if(allPipelineData){
      let pipelineId = pipelineData.PipelineROWID || pipelineData.ROWID;
      let pipeline = allPipelineData.find(e=>e.PipelineROWID==pipelineId);
      if(pipeline){
        setPipelineData(pipeline);
        setAccessControlData(pipeline?.VisibleTo?pipeline?.VisibleTo:[])
      }
    }
  },[allPipelineData])

  useEffect(()=>{
    if(open){
      setAccessControlData(viewPipelineData[0]?.VisibleTo?viewPipelineData[0]?.VisibleTo:[])
    }
  },[open])

  useEffect(
    (e) => {
      if (viewPipelineData && viewPipelineData?.length > 0) {
        console.log("pipeline dta",viewPipelineData);
        
        setPipelineData(viewPipelineData[0]);
        setAccessControlData(viewPipelineData[0]?.VisibleTo?viewPipelineData[0]?.VisibleTo:[])
      }
    },
    [viewPipelineData, refreshData]
  );

  // Save Pipeline Api Call //

  const handleSavePipeline = async () => {
    let data = { ...pipelineData };
    if (data.PipelineName == "" || data.PipelineName == undefined) {
      swal("Alert", "Please fill all the required fields!", "warning");
      return;
    }
    data["MODIFIEDBY"] = userInfo?.email_id;
    data["VisibleTo"] = JSON.stringify(accessControlData);
    data["ROWID"] = pipelineData?.PipelineROWID
      ? pipelineData?.PipelineROWID
      : pipelineData?.ROWID;
    delete data?.PipelineROWID;
    delete data?.Tasks;
    delete data?.PipelineId
    AwsServerService.updatePipelineInTemplate(data)
      .then(async (res) => {
        // swal('Success','Pipeline updated successfully!','success')
        if (pipelineData?.Tasks?.length > 0) {
          await Promise.all(
            pipelineData?.Tasks.map((item) => {
              if (item.TaskROWID || !item?.TaskName) {
                return;
              }
              delete item["id"];
              delete item["flag"];
              item["PipelineROWID"] = pipelineData?.PipelineROWID || pipelineData?.ROWID;
              return AwsServerService.saveTaskInTemplate(item).then((e) => {
              });
            })
          ).then((allRes) => {
            setPageRefreshData((prev) => !prev);
          });
        }else{
          setPageRefreshData((prev) => !prev);
        }
        setAccessControlData([]);
        setIsAdding(false);
        setOpen(!open);
      })
      .catch((err) => {
        swal("Failed", "Some error occured", "warning");
      });
    //  }
  };

    const deparseValue = (structuredValue) => {
      if (!structuredValue) return [];
      return [
        ...(structuredValue.users || []),
        ...(structuredValue.roles || []),
        ...(structuredValue.profiles || []),
      ];
    };

  return (
    <div>
      <AntModal
        open={open}
        wrapClassName={"View-Pipeline-Modal-Wrapper"}
        rootClassName="View-Pipeline-Modal-Root-Wrapper"
        draggable
        title=""
        maskClosable={false}
        width={300}
        className=""
        style={{ top: 170, borderRadius: 50, right: 50 }}
        onCancel={() => {
          setPipelineData(initialPipelineData);
          history.replace('/setting/pipeline')
          setIsAdding(false);
          setViewPipelineData([]);
          setOpen(false);
        }}
        footer={[<></>]}
      >
        <div className="View-Pipeline-Wrapper">
          <Row className="Task-Header" sm={12}> 
            <Col sm={3}>
              <h4 style={{ marginBottom: "0px", opacity: "0.85", marginLeft: "6%", color: "#3e487c" }}>
                Update Pipeline
              </h4>
            </Col>
            <Col sm={9}>
            <Row sm={12} style={{justifyContent:"end"}}>
            <Col sm={2}></Col>
            <Col sm={4} style={{display:"flex",alignItems:"center", justifyContent:"center",position: "absolute", left: "24%"}}>
              <div style={{width:"32%", fontWeight:'500'}}>Access Control :</div>
              <div style={{width:"68%"}} className="forAccessControlPipelines"><HierarchicalDropdown
                        styles={{width:'100%',height:'auto'}}
                        // disabledCondition={}
                        placeholder={"Define Access"}
                        GroupName={["Zoho", "Role", "Profiles"]}
                        isMulti={true}
                        handleChangeUser={(value, option) => setAccessControlData(value)}
                        flag={true}
                        extraStyle={true}
                        selectedUsers={deparseValue(accessControlData)}
                    /> 
              </div>
            </Col>
            <Col sm={3} style={{position: "absolute", left: "56%"}}>
            <Select
             open={!canEdit ? false : undefined}
             id='service-name'
             className='ServicesDropdown' 
             options={zohoServices}
             placeholder='Select service'
             value={pipelineData.ServiceId}
             onChange={(value)=>{  
              setPipelineData({...pipelineData,'ServiceId':value})
             }}
            />
            </Col>
            <Col sm={4} style={{ display: "flex", gap: "10px", justifyContent:"end"}}>
              <Button
                style={!canEdit ? {opacity:0.2} : {}}
                type="primary"
                // icon={<CloseOutlined />}
                onClick={() => {
                  if(!canEdit){message.error("Permission Denied"); return;}
                  handleSavePipeline();
                }}
              >
                {"Update Pipeline"}
              </Button>
              <Button
                icon={<CloseOutlined />}
                onClick={() => {
                  setPipelineData(initialPipelineData);
                  setViewPipelineData([]);
                  history.replace('/setting/pipeline');
                  setIsAdding(false);
                  setOpen(false);
                }}
              ></Button>
            </Col>
            </Row>
            </Col>
          </Row>
          <div className="View-Pipeline-Modal-Body-Wrapper">
            <div className="View-Pipeline-Modal-Body-Child1">
              <Row className="View-Pipeline-Modal-Body" sm={12}>
                <Col className="View-Pipeline-Info-Wrapper" sm={12}>
                  {/* <Row className="Pipeline-Primary-Data-wrapper"> */}
                  <Row
                    className="PipelineNameWrapper"
                    style={{ marginBottom: "10px", display: "flex", flexDirection: "row", alignItems: "center"}}
                  > 
                  <span style={{width: "10%", fontSize: "large", fontWeight: '500', color: '#4f5b6e'}}>
                    Pipeline Name :
                  </span>
                    <Input
                      style={{width: '90%', color: "#4f5b6e", fontWeight: "500", padding: '0px 5px'}}
                      className="Pipeline-Name"
                      size="large"
                      placeholder="Pipeline Name"
                      variant="borderless"
                      value={pipelineData?.PipelineName}
                      onChange={(e) => {
                        e.target.value = e.target.value.trimStart();
                        e.target.value = e.target.value.replace(/[^0-9a-zA-Z\s()]/g, "");
                        setPipelineData({
                          ...pipelineData,
                          PipelineName: e.target.value,
                        });
                      }}
                    />
                  </Row>
                  <Row>
                    <Tabs
                      defaultActiveKey="1"
                      items={[
                        {
                          label: (
                            <Badge
                              color="blue"
                              count={pipelineData?.Tasks?.length}
                              offset={[10, 0]}
                            >
                              <span>Task List</span>
                            </Badge>
                          ),
                          key: "1",
                          children: (
                            <TaskListTab
                              isAdding={isAdding}
                              setIsAdding={setIsAdding}
                              groupFilter={""}
                              viewTaskFunction={viewTaskFunction}
                              viewPipelineData={viewPipelineData}
                              openTaskModal={openTaskModal}
                              setOpenTaskModal={setOpenTaskModal}
                              pipelineData={pipelineData}
                              setPipelineData={setPipelineData}
                              refreshData={refreshData}
                              setPageRefreshData={setPageRefreshData}
                              allPipelineData={allPipelineData}
                              selectedTable={selectedTable}
                              allBlueprintsData={allBlueprintsData}
                              dropdownTasksDataCache={dropdownTasksDataCache}
                              allTasksAndSubtasks   ={allTasksAndSubtasks}
                              setDependencyRefresh  ={setDependencyRefresh}
                              allDependeniesData    ={allDependeniesData}
                              viewPipeline ={true}
                              isPipelineModalClosed = {isPipelineModalClosed}
                            />
                          ),
                        },
                        {
                          label: (
                            <Badge color="blue" count={0} offset={[10, 0]}>
                              <span>Status Timeline</span>
                            </Badge>
                          ),
                          key: "5",
                            children: <></>,
                        },
                        {
                          label: (
                            <Badge color="blue" count={0} offset={[10, 0]}>
                              <span>Activity Stream</span>
                            </Badge>
                          ),
                          key: "6",
                          children: (
                            <ActivityStreamTab
                              pipelineId={viewPipelineData[0]?.PipelineROWID}
                              module="PIPELINETEMPLATE"
                              refreshData={refreshData}
                              setScrollBottom={()=>{}} task={{}} allTasksAndSubtasks={[]} 
				viewTaskFunction={()=>{}}
         selectedActivityFilter={[]} activityFilter={{}} activityDealData = {[]}
                            />
                          ),
                        },
                      ]}
                    />
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </AntModal>
    </div>
  );
};

export default ViewPipelines;
